import React from 'react'
import LandingSreen from 'screens/LandingSreen'
import QuestionScreen from 'screens/QuestionScreen'
import { useQuestionStep } from 'context/QuestionStepContext'

const Home = () => {
  const { currentStep } = useQuestionStep()

  if (currentStep === 0) {
    return <LandingSreen />
  }

  return <QuestionScreen currentStep={currentStep} />
}

export default Home
